import Vue from 'vue';
import Component from 'vue-class-component';
import * as i18next from 'i18next';
import * as api from 'core/api';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export default class OrderServiceComponent extends Vue {
    contentBody: string;

    state: string = 'loading';

    mounted() {
        window.document.title = i18next.t('label_change_or_refund');

        this.loadModel();
    }

    loadModel() {
        new api.ContentService().getText('flight.changerefund').then(
            (result: api.ContentText) => {
                this.contentBody = result.body;
                this.state = 'success';
            },
            (error) => {
                this.state = 'failed';

                if (error.response) {
                    console.log('XHR failed', error.response.status, error.response.data);
                } else {
                    console.log('XHR error', error.message);
                }
            }
        );
    }

    toSupport() {
        (<any>this).$ga.sendEvent('support.new', 'click', 'support.new.click');
        (<any>this).$ga.reachGoal('support.new.click');
        (<any>this).$ga.reachGoal('support.new.click.order');

        window.location.href = '/support/new';
    }
}
